import {GraphObject, GraphLinksModel} from 'gojs';
import {NavigateFunction} from 'react-router-dom';

const {make} = GraphObject;

export const makeModel = ({navigate}: {navigate: NavigateFunction}) => {
  return make(GraphLinksModel, {
    isReadOnly: true,
    linkKeyProperty: 'key', // IMPORTANT! must be defined for merges and data sync when using GraphLinksModel
    modelData: {
      navigate,
    },
  });
};
